export default "__VITE_PUBLIC_ASSET__c9c651f3__"